import { ICM_NAME_FULL } from "@/app/utils/constants";
import React from "react";

const AboutIncred = () => {
    return (
        <div className="mb-s11 flex flex-col items-center justify-center align-middle md:mb-[120px] md:mt-20">
            <div className="flex flex-col md:px-36">
                <div>
                    <h1
                        id="main-heading"
                        className="mb-4 mt-8 text-center text-4xl font-semibold leading-8 md:mt-0 md:text-left md:text-7xl md:leading-[67.5px]"
                    >
                        Welcome to {ICM_NAME_FULL}
                    </h1>
                    <div className="mb-14 hidden border-t-[1px] border-orange-500 md:block md:w-[75%]"></div>
                </div>
                <div className="flex flex-col">
                    <div className="">
                        <div className="mb-6">
                            <p
                                id="para1"
                                className="mb-6 text-center text-base text-neutral-900 md:text-justify"
                            >
                                Here&apos;s what we believe - Smarter Investing should be for
                                everyone.
                            </p>
                            <p
                                id="para2"
                                className="mb-6 text-center text-base text-neutral-900 md:text-justify"
                            >
                                What you do with your money today can change how you live tomorrow.
                                That&apos;s the power of investing right. We have built {ICM_NAME_FULL}{" "}
                                to give everyone a chance to do that.
                            </p>
                        </div>

                        <div className="mb-6">
                            <h3
                                id="sub-heading-1"
                                className="mb-1 text-center font-bold text-neutral-900 md:text-justify"
                            >
                                Democratize Alternate Investing
                            </h3>
                            <p
                                id="sub-para-1"
                                className="text-center text-base text-neutral-900 md:text-justify"
                            >
                                At {ICM_NAME_FULL}, we are solving for the two main problems that
                                investors face when wanting to invest in Alternate Assets.
                            </p>
                        </div>

                        <div className="mb-6">
                            <h3
                                id="sub-heading-1"
                                className="mb-1 text-center font-bold text-neutral-900 md:text-justify"
                            >
                                Access
                            </h3>
                            <p
                                id="sub-para-1"
                                className="text-center text-base text-neutral-900 md:text-justify"
                            >
                                You will have access to alternative{" "}
                                <span className="underline">
                                    <a href={process.env.ICM_URL}>investment opportunities</a>
                                </span>{" "}
                                which were earlier available only to High-Net-Worth Individuals and
                                Companies. These opportunities are now available to you too and you
                                can now start investing with as low as one share.
                            </p>
                        </div>

                        <div className="mb-6">
                            <h3
                                id="sub-heading-2"
                                className="mb-1 text-center font-bold text-neutral-900 md:text-justify"
                            >
                                Trust
                            </h3>
                            <p
                                id="sub-para-2"
                                className="text-center text-base text-neutral-900 md:text-justify"
                            >
                                We know it&apos;s hard to trust when it comes to investing. We are
                                here to change that. Every decision we make is centered around your
                                need and convenience, and to earn your trust. We are simplifying the
                                entire process to make it very easy for you to be in control of your
                                investments.
                            </p>
                        </div>

                        <div className="mb-6">
                            <p
                                id="para3"
                                className="text-center text-base text-neutral-900 md:text-justify"
                            >
                                {ICM_NAME_FULL} was launched in June 2026 with the acquisition of
                                Orowealth, one of the pioneers of the digital wealth ecosystem and a
                                leading investment platform with an AUM of ₹1,350+ Cr.
                            </p>
                        </div>

                        <div className="mb-6">
                            <p
                                id="para4"
                                className="text-center text-base text-neutral-900 md:text-justify"
                            >
                                Under the InCred fold, {ICM_NAME_FULL} will have significant
                                competitive advantages with access to a deep network of issues and
                                industry leading credit & risk assessment capabilities. In addition
                                to its Fintech capabilities, {ICM_NAME_FULL} will also have the added
                                advantage of the support of a large financial services organization.
                                This will greatly help in the journey of making alternate assets
                                easy, trustworthy, and lucrative for the end investor.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutIncred;
